import { IDropdownOption } from "@fluentui/react";

const anonimityWarning: string = 'ObservationPage.ReportAnonymouslyEnterContactDetails';

export const anonimityOptions: IDropdownOption[] = [
    { key: 1, text: 'ConfirmationDialog.Yes', data: anonimityWarning },
    { key: 0, text: 'ConfirmationDialog.No', data: anonimityWarning }
]